module.exports = __webpack_public_path__ + "img/credigo.6aeaf26.png";